<template src='./registry-organization-information.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      organizationId: this.$route.params.organizationId,
      organization: {},
      pageLoader: false,
      help: {
        root: Vue.$helpConfig.registryOrganizationDetails
      }
    }
  },
  created () {
    this.setupPage()
  },
  methods: {
    setupPage () {
      this.pageLoader = true
      const infoUrl = Vue.$apiConfig.registryOrganizationDetailsGet.replace('{organizationId}', this.$route.params.organizationId)
      this.$http.get(infoUrl).then(
        response => {
          this.logConsole(response)
          this.organization = response.data.payload
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.pageLoader = false
        }
      )
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}

  .list-dense {
    min-height: 26px !important;
    padding-left: 0px !important;
  }
  .list-icon {
    padding: 2px 0px !important;
    margin-right: 16px !important;
    margin-top: 2px !important;
    margin-bottom: 2px !important;
  }

  .list-contents {
    padding: 2px 0px !important;
  }

  .v-list-item__title {
    font-weight: 400 !important;
  }

</style>
